import { ActionIcon, Button, Group, Modal, Text, Tooltip } from "@mantine/core";
import { useLanguage } from "../../stores/LanguageStore";
import { IconFolderMinus } from "@tabler/icons-react";
import { useMemo, useState } from "react";
import { notifications } from "@mantine/notifications";
import { useDisclosure } from "@mantine/hooks";
import { useFolderStore } from "../../stores/FolderStore";
import { useParams } from "react-router-dom";

const ItemRemoveFromFolder = ({
  handleEdit,
  id,
  title_bold,
  apiRef,
  onFinish,
  setRows,
  isButton,
  ...buttonProps
}) => {
  const lang = useLanguage((s) => s.language);
  const [opened, { open, close }] = useDisclosure();
  const [loading, setLoading] = useState(false);
  const folders = useFolderStore((s) => s.folders);
  const { folderId } = useParams();

  const folder = useMemo(() => {
    return folders.find((x) => x.id === parseInt(folderId));
  }, [folderId, folders]);

  const main = () => {
    setLoading(true);
    handleEdit({ id, folder_id: 0 })
      .then((res) => {
        close();
        notifications.show({
          message: lang.components.folder_remove.dialog.sucess,
          color: "tertiary.8",
        });

        if (apiRef) {
          let selected = Array.from(apiRef.current.getSelectedRows().keys());
          apiRef.current.setRowSelectionModel(selected.filter((x) => x !== id));
          document.querySelectorAll(`[data-id='${id}']`).forEach((el) => {
            el.style.animation = `forwards 1.5s deletedAnim ease`;
          });
          setTimeout(() => {
            apiRef.current.updateRows([{ id, _action: "delete" }]);
            setRows?.((prev) => prev.filter((x) => x.id !== id));
          }, 750);
        }
        onFinish?.();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      {isButton ? (
        <Button
          onClick={(e) => {
            e.stopPropagation();
            open();
          }}
          leftSection={<IconFolderMinus size={18} />}
          fw={500}
          color="red"
          variant="subtle"
          justify="start"
          {...buttonProps}
        >
          {lang.components.folder_remove.button_label}
        </Button>
      ) : (
        <Tooltip label={lang.components.folder_remove.button_label}>
          <ActionIcon
            variant="subtle"
            onClick={(e) => {
              e.stopPropagation();
              open();
            }}
            color="red"
            {...buttonProps}
          >
            <IconFolderMinus size={16} />
          </ActionIcon>
        </Tooltip>
      )}

      <Modal
        opened={opened}
        onClose={close}
        title={
          <Text size="md" truncate="end">
            {lang.components.folder_remove.title} <b>{title_bold}</b>
          </Text>
        }
        zIndex={9999}
        centered
        styles={{
          content: {
            boxShadow: "red 0 0 6px",
            border: "1px solid #a00",
          },
          title: {
            maxWidth: "92%",
          },
        }}
      >
        <Text size="sm">
          {lang.components.folder_remove.dialog.text}{" "}
          <b>{folder?.name || ""}</b> <br /> <br />
          <b> {lang.components.folder_remove.dialog.text2} </b>
        </Text>

        <Group justify="end" mt={"lg"}>
          <Button
            variant="subtle"
            onClick={(e) => {
              e.stopPropagation();
              close();
            }}
            disabled={loading}
            size="md"
          >
            {lang.components.folder_remove.dialog.cancel_button}
          </Button>
          <Button color="red" onClick={main} loading={loading} size="md">
            {lang.components.folder_remove.dialog.submit_button}
          </Button>
        </Group>
      </Modal>
    </>
  );
};

export default ItemRemoveFromFolder;
